{
  "version": 1,
  "asset_id": "99553fc6-46fa-4765-be4b-9a9b314f59f1",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/99553fc6-46fa-4765-be4b-9a9b314f59f1/boat-hewescraft.png",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/99553fc6-46fa-4765-be4b-9a9b314f59f1/boat-hewescraft.png",
  "original_filename": "boat-hewescraft.png",
  "size": 2501782,
  "content_type": "image/png",
  "created_at": "2026-07-02T23:04:15Z"
}
